import { AccountingSystemFormType } from '../forms/accountingSystemForm';

export const getSubmitData = (values: AccountingSystemFormType) => ({
  sessionLengthInDays: values.sessionLengthInDays,
  passwordExpiresInDays: values.isPasswordLimited
    ? values.passwordExpiresInDays!
    : null,
});
